import moment from "moment";
import { useContext, useEffect, useState } from "react";
import StateContext from "../../../contextAPI/context";
import { useNavigate } from "react-router-dom";
import SearchForm from "../../../component/search-form";

// Importing scrollbar library
import SimpleBarReact from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

// Adding new tooltip
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "../../../redux/actions/user";
import { getActivityCustomFields, getActivityPerformance, getActivityPerformanceByActivity, getActivityPerformanceFileList } from "../../../redux/actions/performance";
import { getAllAssetByActivityAssignmentId } from "../../../redux/actions/asset"
import { RESET_ACTIVITY_PERFORMANCE_TABLE_INFO, SET_ACTIVITY, SET_JOBS } from "../../../redux/constants";

const ActivitySideList = ({
  activitydata,
  setActivityData,
  setNewJson,
  setOpenTab,
  activityPerformance,
  setActivityPerformance,
  setFileNames,
  setActivityPerformed,
  setPerformanceValue,
  activity_assignment_id,
  setShowActivity,
  setObj,
  email,
  setIsMobileView,
  isMobileView,
  setUserInfo,
  setEditState,
  setRenderData,
  selectActivityId,
  setSelectedActivityID,
  contentHeightRef,
  sliderRef,
  setActivityName,
  company_id,
  setUserDept,
}) => {

  const statusColor = (status) => {
    switch (status) {
      case "completed":
        return "bg-green-200";
      case "completed with delay":
        return "bg-teal-200";
      case "pending":
        return "bg-yellow-200";
      case "in progress":
        return "bg-yellow-200";
      case "extension":
        return "bg-[#fed7aa]";
      default:
        return "bg-slate-100";
    }
  };

  const getColor = (status, element, activitydataID, itemActivityId) => {
    if (element.user_id) {
      if (element.user?.email === email) {
        if (activitydataID === itemActivityId) {
          return "bg-blue-300";
        } else {
          return "bg-blue-100";
        }
      } else {
        if (activitydataID === itemActivityId) {
          return "bg-blue-300";
        } else {
          return "bg-slate-100";
        }
      }
    } else if (element.department_id) {
      if (element.department_id === filteredUserData?.department) {
        if (activitydataID === itemActivityId) {
          return "bg-blue-300";
        } else {
          return "bg-blue-100";
        }
      } else {
        if (activitydataID === itemActivityId) {
          return "bg-blue-300";
        } else {
          return "bg-slate-100";
        }
      }
    } else if (element.user_email) {
      if (element.user_email === email) {
        if (activitydataID === itemActivityId) {
          return "bg-blue-300";
        } else {
          return "bg-blue-100";
        }
      } else {
        if (activitydataID === itemActivityId) {
          return "bg-blue-300";
        } else {
          return "bg-slate-100";
        }
      }
    } else {
      if (activitydataID === itemActivityId) {
        return "bg-blue-300";
      } else {
        return "bg-slate-100";
      }
    }
  };

  const dispatch = useDispatch();

  const { setSubmitPerform } = useContext(StateContext);
  const navigate = useNavigate();
  const [activitylist, setActivityList] = useState([]);
  
  // Creating state to store userlist and filtered user
  const [filteredUserData, setFilteredUserData] = useState();

  // Redux State
  const { userData } = useSelector( state => state.user );
  const { activities } = useSelector( state => state.performance );

  useEffect(() => {
    dispatch(getUserData())
  }, [dispatch]);

  useEffect(() => {
    if (userData) {
      const filterUser = userData.filter((ele) => ele.email === email);
      if (filterUser.length > 0) {
        setFilteredUserData(filterUser[0]);
      }
    }
  }, [userData]);

  useEffect(() => {
    setActivityList(activities);
    if (selectActivityId) {
      const filterActivity = activities.filter(
        (item) => item.activity_id === selectActivityId
      );
      const filterIndex = activities.findIndex(
        (item) => item.activity_id === selectActivityId
      );
      handleClick(filterActivity[0], filterIndex);
    } else {
      handleClick(activities[0], 0);
    }
    return () => {
      setActivityList([]);
    }
  }, [activities]);

  const handleSearch = (e) => {
    if (e.target.value === "") {
      return setActivityList(activities);
    }
    const result = activities.filter((item) =>
      item.activity.name.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setActivityList(result);
  };

  const handleClick = async (item, index) => {
    if (item) {
      dispatch({type: RESET_ACTIVITY_PERFORMANCE_TABLE_INFO});
      setActivityName(item?.activity?.name);
      setSelectedActivityID(item.activity.id);
      setActivityData(item.activity);
      setUserInfo(item);
      dispatch(getActivityCustomFields(item.activity.id));
      dispatch(getActivityPerformance(item.activity_assignment_mapping_id));
      setNewJson([]);
      setEditState(false);
      setSubmitPerform(true);
      setRenderData(false);
      setActivityPerformed(false);
      setShowActivity(true);
      dispatch(getActivityPerformanceByActivity(item.activity.id, (res) => {
        if (Object.keys(res.data.data).length !== 0) {
            const date_value = document.getElementById("datepickr")?.value;
            const {
              activity_performance_id,
              activity_id,
              based_on,
              file_name,
              remarks,
              expenses,
              todo_custom_controls,
            } = res.data.data;
            setActivityPerformed(true);
            let activityData = {
              activity_id: activity_id,
              performance_id: activity_performance_id,
              based_on: based_on,
              file_name: file_name,
              remarks: remarks,
              expenses: expenses,
              date: date_value,
              custom_fields: todo_custom_controls,
            }
            dispatch({type: SET_ACTIVITY, payload: activityData });
            dispatch({type: SET_JOBS, payload: todo_custom_controls})
          } else {
            dispatch({type: SET_ACTIVITY, payload: [] });
          }
      }))
      setOpenTab(1);
      setActivityPerformance({
        activity_id: item.activity.id,
        performed_by: email,
        activity_assignment_id: activity_assignment_id,
        activity_assignment_mapping_id: item.activity_assignment_mapping_id,
        based_on: null,
        custom_fields: [],
        file_name: null,
        file_path: null,
        expenses: "",
        remarks: "",
      });
      setFileNames([]);
      dispatch(getAllAssetByActivityAssignmentId(activity_assignment_id));
      setPerformanceValue([]);
      setObj(item);
      setIsMobileView(true);
      if (index !== -1) {
        sliderRef?.current?.slickGoTo(index);
      }
      dispatch(getActivityPerformanceFileList(item.activity_assignment_mapping_id))
      let name =
        item?.user?.name !== ""
          ? item?.user?.name
          : item?.department?.name !== ""
          ? item?.department?.name
          : item?.user_email;
      setUserDept(name);
    }
  };

  // Setting up custome height
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    if (contentHeightRef?.current.clientHeight) {
      setContentHeight(contentHeightRef?.current?.clientHeight);
    }
  }, [contentHeightRef?.current?.clientHeight]);

  const maskingEmail = (email) => {
    let maskid = "";
    let prefix = email.substring(0, email.lastIndexOf("@"));
    console.log("prefix --", prefix);
    let postfix = email.substring(email.lastIndexOf("@"));

    for (let i = 0; i < prefix.length; i++) {
      if (i == 0) {
        maskid = maskid + prefix[i].toString();
      } else {
        maskid = maskid + "*";
      }
    }
    maskid = maskid + postfix;
    return maskid;
  };

  const getActivityOwnerName = (item) => {
    if (item.user) {
      return (
        <div className="space-x-2">
          <span className="fas fa-user"></span>
          <span>{item.user.name}</span>
        </div>
      );
    } else if (item.user_email) {
      return (
        <div className="space-x-2">
          <span className="fas fa-user-secret"></span>
          <span>{maskingEmail(item.user_email)}</span>
        </div>
      );
    } else if (item.department) {
      return (
        <div className="space-x-2">
          <span className="fas fa-user-friends"></span>
          <span>{item.department.name}</span>
        </div>
      );
    } else return null;
  };

  const linkLoopActivityName = (activityId) => {
    const activityName = activitylist.filter(
      (item) => item.activity_id === activityId
    )[0]?.activity.name;
    return activityName;
  };

  return (
    <div
      className={`${
        isMobileView ? "hidden" : "block"
      } p-6 w-full block sm:block sm:p-0 space-y-4 sm:w-full overflow-auto scroll-auto`}
    >
      <div className="flex flex-row items-center border-b space-x-2">
        <div>
          <button className="btn-sm bg-slate-100" onClick={() => navigate(-1)}>
            &larr; Back
          </button>
        </div>
        <h4 className="font-bold text-2xl sm:text-base sm:p-4">To Dos</h4>
      </div>
      <div className="px-2">
        <SearchForm placeholder="Search" onChange={(e) => handleSearch(e)} />
      </div>
      <SimpleBarReact
        style={{
          maxHeight: contentHeight > 555 ? `${contentHeight - 100}px` : "555px",
        }}
      >
        <div
          className="block p-2 space-y-2 overflow-x-hidden"
        >
          {activitylist.length === 0 ? (
            <p>No To Dos found.</p>
          ) : (
            activitylist.map((item, index) => {
              return (
                <div
                  className={`h-16 rounded flex flex-col justify-center cursor-pointer ${getColor(
                    item.status,
                    item,
                    activitydata.id,
                    item.activity.id
                  )}`}
                  onClick={() => {
                    setActivityPerformance({});
                    handleClick(item, index);
                  }}
                >
                  <div className="flex items-center justify-between px-3">
                    <div className="w-1/2 flex items-center space-x-1">
                      <p
                        title={item.activity.name}
                        className="text-sm font-semibold leading-6 overflow-hidden whitespace-nowrap text-ellipsis"
                      >
                        {item.activity.name}
                      </p>
                      <p className="text-xs whitespace-nowrap space-x-1">
                        {item.loop_activity && (
                          <Tippy
                            content={linkLoopActivityName(item.loop_activity)}
                          >
                            <span className="fas fa-infinity"></span>
                          </Tippy>
                        )}
                        {item.link_activity && (
                          <Tippy
                            content={linkLoopActivityName(item.link_activity)}
                          >
                            <span className="fas fa-link"></span>
                          </Tippy>
                        )}
                        {!item?.can_perform && (
                          <span className="fas fa-lock"></span>
                        )}
                      </p>
                    </div>
                    <div
                      className={`px-2 py-1 rounded-xl text-xs font-medium w-20 text-center text-slate-700 whitespace-nowrap ${statusColor(
                        item.status
                      )}`}
                    >
                      {item.status}
                    </div>
                  </div>
                  <div className="flex items-center justify-between px-3">
                    <p className="text-xs leading-6 break-words">
                      {getActivityOwnerName(item)}
                    </p>
                    <p className="text-xs whitespace-nowrap">
                      {item?.estimated_time
                        ? moment(item.estimated_time).format("D MMM YY HH:mm")
                        : ""}
                    </p>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </SimpleBarReact>
    </div>
  );
};

export default ActivitySideList;
